import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <div className="bg-white p-8 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Privacy Policy
        </h1>
        <p className="text-gray-600 mb-6">
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <div className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              1. Information We Collect
            </h2>
            <p className="text-gray-600">
              We collect information you provide directly to us, such as when
              you create an account, fill out a form, or contact us. This may
              include your name, email address, phone number, and other contact
              or identifying information.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              2. How We Use Your Information
            </h2>
            <p className="text-gray-600">
              We use the information we collect to:
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Provide, maintain, and improve our services</li>
                <li>Respond to your comments, questions, and requests</li>
                <li>
                  Send you technical notices, updates, and support messages
                </li>
                <li>Monitor and analyze trends, usage, and activities</li>
              </ul>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              3. Information Sharing
            </h2>
            <p className="text-gray-600">
              We do not share your personal information with third parties
              except:
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>With your consent</li>
                <li>For legal compliance or protection</li>
                <li>
                  With service providers who assist us in operating our services
                </li>
              </ul>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              4. Security
            </h2>
            <p className="text-gray-600">
              We implement reasonable security measures to protect your
              information. However, no method of transmission over the Internet
              is 100% secure.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              5. Changes to This Policy
            </h2>
            <p className="text-gray-600">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new policy on this page.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              6. Contact Us
            </h2>
            <p className="text-gray-600">
              If you have any questions about this Privacy Policy, please
              contact us at privacy@yourcompany.com.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
